import React, { Component, Fragment } from 'react';
import { Col, Form, InputNumber, Row, Select, Checkbox, Divider } from 'antd';

const Option = Select.Option;

export class SellForm extends Component {
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;

        const showSota = getFieldValue('type') === 'buy_sell';

        return (
            <div>
                <Row gutter={24}>
                    <Col md={6}>
                        <Form.Item label="Type">
                            {getFieldDecorator(`${mode}_type`, {
                                initialValue: 'trail'
                            })(
                                <Select>
                                    <Option value="trail">Profit Trail</Option>
                                    <Option value="percent_profit">Percent Profit</Option>
                                    <Option value="apex_percent_profit">
                                        Percent Profit - Dynamic
                                    </Option>
                                    <Option value="remote_signal_price">Remote Signal Price</Option>
                                    <Option value="hold_position">Hold Position</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    {this.renderProfitTrailFields()}
                    {this.renderDynamicProfitFields()}
                    {this.renderPercentProfitFields()}
                    {this.renderRemoteSignalFields()}

                    {showSota ? (
                        <Fragment>
                            <Col md={12}>
                                <Form.Item
                                    label="Sell on Technical Analysis"
                                    extra={
                                        'Position will sell when either your exit type or sell indicators meets criteria'
                                    }
                                >
                                    {getFieldDecorator(`${mode}_ta_enabled`, {
                                        initialValue: false,
                                        valuePropName: 'checked'
                                    })(<Checkbox />)}
                                </Form.Item>
                            </Col>

                            {this.renderSellOnTAFields()}
                        </Fragment>
                    ) : null}
                </Row>
            </div>
        );
    }

    renderSellOnTAFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;

        if (getFieldValue(`${mode}_ta_enabled`) === true) {
            return (
                <div>
                    <Divider>Sell on Technical Analysis</Divider>
                    <Col md={6}>
                        <Form.Item label="Sell on TA order Type">
                            {getFieldDecorator(`${mode}_ta_order_type`, {
                                initialValue: 'market'
                            })(
                                <Select>
                                    <Option value="market">Market</Option>
                                    <Option value="limit">Limit</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col md={6}>
                        <Form.Item label="Sell in profit only">
                            {getFieldDecorator(`${mode}_ta_in_profit`, {
                                initialValue: false,
                                valuePropName: 'checked'
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>
                    <Col md={6}>
                        <Form.Item label="Sell in Profit min amount (%)">
                            {getFieldDecorator(`${mode}_ta_in_profit_amount`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0.15
                            })(<InputNumber addonAfter="%" />)}
                        </Form.Item>
                    </Col>
                </div>
            );
        }
        return null;
    }

    renderRemoteSignalFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        if (getFieldValue(`${mode}_type`) === 'remote_signal_price') {
            return (
                <React.Fragment>
                    <Col md={12}>
                        <Form.Item
                            label="Default Profit amount (%)"
                            extra="When a signal returns no take profit price"
                        >
                            {getFieldDecorator(`${mode}_percent_profit_amount`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 1
                            })(<InputNumber addonAfter="%" />)}
                        </Form.Item>
                    </Col>
                </React.Fragment>
            );
        }
        return null;
    }

    renderPercentProfitFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        if (getFieldValue(`${mode}_type`) === 'percent_profit') {
            return (
                <React.Fragment>
                    <Col md={12}>
                        <Form.Item label="Profit amount (%)">
                            {getFieldDecorator(`${mode}_percent_profit_amount`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 1
                            })(<InputNumber addonAfter="%" />)}
                        </Form.Item>
                    </Col>
                </React.Fragment>
            );
        }
        return null;
    }

    renderDynamicProfitFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        if (getFieldValue(`${mode}_type`) === 'apex_percent_profit') {
            return (
                <React.Fragment>
                    <Col md={4}>
                        <Form.Item label="Min Profit amount (%)">
                            {getFieldDecorator(`${mode}_min_profit_amount`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0.3
                            })(<InputNumber addonAfter="%" />)}
                        </Form.Item>
                    </Col>

                    <Col md={4}>
                        <Form.Item
                            label={'Period'}
                            extra={'Choose a period which suits your buy strategy'}
                        >
                            {getFieldDecorator(`${mode}_period`, {
                                initialValue: '1h'
                            })(
                                <Select>
                                    <Option value={'1m'}>1m</Option>
                                    <Option value={'3m'}>3m</Option>
                                    <Option value={'5m'}>5m</Option>
                                    <Option value={'15m'}>15m</Option>
                                    <Option value={'30m'}>30m</Option>
                                    <Option value={'1h'}>1h</Option>
                                    <Option value={'2h'}>2h</Option>
                                    <Option value={'4h'}>4h</Option>
                                    <Option value={'12h'}>12h</Option>
                                    <Option value={'1d'}>1d</Option>
                                    <Option value={'3d'}>3d</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </React.Fragment>
            );
        }
        return null;
    }
    renderProfitTrailFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        if (getFieldValue(`${mode}_type`) === 'trail') {
            return (
                <React.Fragment>
                    <Col md={4} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Arm (%)" extra="Initial profit target to arm trail ">
                            {getFieldDecorator(`${mode}_profit_trail_arm`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 1
                            })(<InputNumber addonAfter="%" />)}
                        </Form.Item>
                    </Col>

                    <Col md={5} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item
                            label="Stop loss (%)"
                            extra="Once armed, how much can we afford to lose"
                        >
                            {getFieldDecorator(`${mode}_profit_trail_stop_loss`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0.2
                            })(<InputNumber addonAfter="%" />)}
                        </Form.Item>
                    </Col>

                    <Col md={5} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Step (%)" extra="Move stop loss up in steps">
                            {getFieldDecorator(`${mode}_profit_trail_step_percentage`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0
                            })(<InputNumber addonAfter="%" />)}
                        </Form.Item>
                    </Col>
                </React.Fragment>
            );
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/Shared/SellForm.js